<template>
	<div class="flex items-center justify-center min-h-screen">
		<i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
	</div>
</template>

<script setup lang="ts">
import { onMounted } from "vue"
import { useRouter } from "vue-router"
import { authProvider } from "../auth/authProviderFactory"
import { appAuth } from "../auth/appAuth"
import { peekOriginalUriFromOkta, peekPostLoginPath } from "../auth/postLoginRedirect"

const router = useRouter()

onMounted(async () => {
	try {
		const { accessToken } = await authProvider.handleCallback()
		if (accessToken) {
			localStorage.setItem("token", accessToken)
			const result = await appAuth.loginToAppWithOktaToken(accessToken)
			if (result === "ok") {
				// Back to whatever was asked for before signing in — a request opened from an
				// email link, typically. The landing page is only the fallback.
				//
				// Read, not taken: the destination stays until its own page is reached. This
				// navigation can still be undone by a guard that finds no session yet and signs in
				// again, and taking it here left that second round trip with nothing to go on.
				const destination = peekPostLoginPath() ?? peekOriginalUriFromOkta()

				if (destination) {
					router.push(destination)
				} else if (router.currentRoute.value.path.startsWith("/login")) {
					// No destination and still on the callback: the landing page it is.
					//
					// Only from here, though. Signing in is a race between this screen, the login
					// screen and Okta restoring the address it kept, and this one often finishes
					// last. Finding no destination then does not mean there never was one — it
					// usually means another of them already took the reader to it and it was
					// dropped on arrival. Pushing /app anyway is what took the article away a
					// fraction of a second after it appeared.
					router.push("/app")
				}
			} else {
				sessionStorage.setItem("error", result)
				router.push("/login")
			}
		} else {
			router.push("/login")
		}
	} catch (error) {
		console.error("Auth callback error:", error)
		router.push("/login")
	}
})
</script>
